import { useSupabaseAuth } from '../../contexts/SupabaseAuthContext';
import { useAppIdleRefresh } from '../../hooks/useAppIdleRefresh';

/** Mount inside QueryClientProvider + SupabaseAuthProvider to refresh stale data after idle. */
export function AppForegroundRefreshHost(): null {
  const { isLoaded, isSignedIn } = useSupabaseAuth();
  useAppIdleRefresh(isLoaded && isSignedIn);
  return null;
}
